import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { css } from 'goober';
import React, { useRef, useEffect, useState, useCallback, useMemo } from 'react';
var defaultStrings = {
  allItemsAreSelected: "All items are selected.",
  clearSearch: "Clear Search",
  clearSelected: "Clear Selected",
  noOptions: "No options",
  search: "Search",
  selectAll: "Select All",
  selectSomeItems: "Select..."
};
var defaultProps = {
  value: [],
  focusSearchOnOpen: true,
  hasSelectAll: true,
  className: "multi-select",
  debounceDuration: 200,
  options: []
};
var MultiSelectContext = /*#__PURE__*/React.createContext({});

var MultiSelectProvider = function MultiSelectProvider(_ref) {
  var props = _ref.props,
      children = _ref.children;

  var t = function t(key) {
    var _props$overrideString;

    return ((_props$overrideString = props.overrideStrings) == null ? void 0 : _props$overrideString[key]) || defaultStrings[key];
  };

  return React.createElement(MultiSelectContext.Provider, {
    value: _objectSpread(_objectSpread({
      t: t
    }, defaultProps), props)
  }, children);
};

var useMultiSelect = function useMultiSelect() {
  return React.useContext(MultiSelectContext);
};
/**
 * combines classNames in a friendly way
 *
 * @param {*} classes
 */


var cn = function cn() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.join(" ");
};
/**
 * similar to `useEffect` but gets triggered only when value changes
 * @param fn executable function on dependency updates
 * @param inputs dependency array
 */


function useDidUpdateEffect(fn, inputs) {
  var didMountRef = useRef(false);
  useEffect(function () {
    if (didMountRef.current) fn();else didMountRef.current = true;
  }, inputs);
}

var debounce = function debounce(func, wait) {
  var timeout;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(null, args);
    }, wait);
  };
};
/**
 * Filters React Select options and sorts by similarity to a search filter.
 * Handles partial matches, eg. searching for "Waberg High" will find "Raoul
 * Wallenberg Traditional High School". Case insensitive. Ignores
 * non-alphanumeric characters.
 *
 * @param  options  An unfiltered list of Options.
 * @param? filter  A string to compare against Option labels.
 * @param? substitutions  Strings with multiple spellings or variations that we
 *           expect to match, eg. accented characters or abbreviated words.
 *
 * @return A filtered and sorted array of Options.
 */


function filterOptions(options, filter, substitutions) {
  // If the filter is blank, return the full list of Options.
  if (!filter) {
    return options;
  }

  var cleanFilter = cleanUpText(filter, substitutions);
  return options // Filter out undefined or null Options.
  .filter(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value;
    return label != null && value != null;
  }) // Create a {score, Option} pair for each Option based on its label's
  // similarity to the filter text.
  .map(function (option) {
    return {
      option: option,
      score: typeaheadSimilarity(cleanUpText(option.label, substitutions), cleanFilter)
    };
  }) // Only include matches of the entire substring, with a slight
  // affordance for transposition or extra characters.
  .filter(function (pair) {
    return pair.score >= cleanFilter.length - 2;
  }) // Sort 'em by order of their score.
  .sort(function (a, b) {
    return b.score - a.score;
  }) // …and grab the original Options back from their pairs.
  .map(function (pair) {
    return pair.option;
  });
}
/**
 * Scores the similarity between two strings by returning the length of the
 * longest common subsequence. Intended for comparing strings of different
 * lengths; eg. when matching a typeahead search input with a school name.

 * Meant for use in an instant search box where results are being fetched
 * as a user is typing.
 *
 * @param  a  The longer string (though, we flip them if it's shorter).
 * @param  b  The shorter string, eg. a typeahead search input.
 *
 * @return The length of the longest common subsequence. Higher scores indicate
 *           closer matches.
 */


function typeaheadSimilarity(a, b) {
  var aLength = a.length;
  var bLength = b.length;
  var table = [];

  if (!aLength || !bLength) {
    return 0;
  } // Ensure `a` isn't shorter than `b`.


  if (aLength < bLength) {
    var _ref3 = [b, a];
    a = _ref3[0];
    b = _ref3[1];
  } // Early exit if `a` includes `b`; these will be scored higher than any
  // other options with the same `b` (filter string), with a preference for
  // shorter `a` strings (option labels).


  if (a.indexOf(b) !== -1) {
    return bLength + 1 / aLength;
  } // Initialize the table axes:
  //
  //    0 0 0 0 ... bLength
  //    0
  //    0
  //
  //   ...
  //
  // aLength
  //


  for (var x = 0; x <= aLength; ++x) {
    table[x] = [0];
  }

  for (var y = 0; y <= bLength; ++y) {
    table[0][y] = 0;
  } // Populate the rest of the table with a dynamic programming algorithm.


  for (var _x = 1; _x <= aLength; ++_x) {
    for (var _y = 1; _y <= bLength; ++_y) {
      table[_x][_y] = a[_x - 1] === b[_y - 1] ? 1 + table[_x - 1][_y - 1] : Math.max(table[_x][_y - 1], table[_x - 1][_y]);
    }
  }

  return table[aLength][bLength];
}
/**
 * Apply string substitutions, remove non-alphanumeric characters, and convert
 * all letters to uppercase.
 *
 * eg. 'Scoil Bhríde Primary School' may become 'SCOILBHRIDEPRIMARYSCHOOL'.
 *
 * @param  input  An unsanitized input string.
 * @param  substitutions  Strings with multiple spellings or variations that we
 *          expect to match, for example accented characters or abbreviated
 *          words.
 *
 * @return The sanitized text.
 */


function cleanUpText(input, substitutions) {
  if (!input) {
    return "";
  } // Uppercase and remove all non-alphanumeric, non-accented characters.
  // Also remove underscores.


  input = input.toUpperCase().replace(/((?=[^\u00E0-\u00FC])\W)|_/g, "");

  if (!substitutions) {
    return input;
  }

  var safeSubstitutions = substitutions; // For Flow.
  // Replace all strings in `safeSubstitutions` with their standardized
  // counterparts.

  return Object.keys(safeSubstitutions).reduce(function (output, substitution) {
    var unsubbed = new RegExp(substitution, "g");
    return output.replace(unsubbed, safeSubstitutions[substitution]);
  }, input);
}

var Cross = function Cross() {
  return React.createElement("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-search-clear-icon gray"
  }, React.createElement("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), React.createElement("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  }));
};

var DefaultRenderer = /*#__PURE__*/css({
  "& input,& span": {
    verticalAlign: "middle",
    margin: 0
  },
  span: {
    display: "inline-block",
    paddingLeft: "5px"
  },
  "&.disabled": {
    opacity: 0.5
  }
});

var DefaultItemRenderer = function DefaultItemRenderer(_ref4) {
  var checked = _ref4.checked,
      option = _ref4.option,
      onClick = _ref4.onClick,
      disabled = _ref4.disabled;
  return React.createElement("div", {
    className: cn(DefaultRenderer, "item-renderer", disabled && "disabled")
  }, React.createElement("input", {
    type: "checkbox",
    onChange: onClick,
    checked: checked,
    tabIndex: -1,
    disabled: disabled
  }), React.createElement("span", null, option.label));
};
/**
 * This component represents an individual item in the multi-select drop-down
 */


var ItemContainer = /*#__PURE__*/css({
  boxSizing: "border-box",
  cursor: "pointer",
  display: "block",
  padding: "var(--rmsc-p)",
  outline: 0,
  "&:hover,&:focus": {
    background: "var(--rmsc-hover)"
  },
  "&.selected": {
    background: "var(--rmsc-selected)"
  }
});

var SelectItem = function SelectItem(_ref5) {
  var _ref5$itemRenderer = _ref5.itemRenderer,
      ItemRenderer = _ref5$itemRenderer === void 0 ? DefaultItemRenderer : _ref5$itemRenderer,
      option = _ref5.option,
      checked = _ref5.checked,
      focused = _ref5.focused,
      tabIndex = _ref5.tabIndex,
      disabled = _ref5.disabled,
      onSelectionChanged = _ref5.onSelectionChanged,
      onClick = _ref5.onClick;
  var itemRef = useRef();
  useEffect(function () {
    updateFocus(); // eslint-disable-next-line
  }, [checked, focused]);

  var toggleChecked = function toggleChecked() {
    onSelectionChanged(!checked);
  };

  var handleClick = function handleClick(e) {
    toggleChecked();
    onClick(e);
  };

  var updateFocus = function updateFocus() {
    if (focused && !disabled && itemRef) {
      itemRef.current.focus();
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    switch (e.which) {
      case 13: // Enter

      case 32:
        // Space
        toggleChecked();
        break;

      default:
        return;
    }

    e.preventDefault();
  };

  return React.createElement("label", {
    className: cn(ItemContainer, "select-item", checked && "selected"),
    role: "option",
    "aria-selected": checked,
    tabIndex: tabIndex,
    ref: itemRef,
    onKeyDown: handleKeyDown
  }, React.createElement(ItemRenderer, {
    option: option,
    checked: checked,
    onClick: handleClick,
    disabled: disabled
  }));
};
/**
 * This component represents an unadorned list of SelectItem (s).
 */


var SelectListUl = /*#__PURE__*/css({
  margin: 0,
  paddingLeft: 0,
  li: {
    listStyle: "none",
    margin: 0
  }
});
var skipIndex = 2;

var SelectList = function SelectList(_ref6) {
  var options = _ref6.options,
      focusIndex = _ref6.focusIndex,
      _onClick = _ref6.onClick;

  var _useMultiSelect = useMultiSelect(),
      disabled = _useMultiSelect.disabled,
      value = _useMultiSelect.value,
      onChange = _useMultiSelect.onChange,
      ItemRenderer = _useMultiSelect.ItemRenderer;

  var handleSelectionChanged = function handleSelectionChanged(option, checked) {
    if (disabled) {
      return;
    }

    onChange(checked ? [].concat(_toConsumableArray(value), [option]) : value.filter(function (o) {
      return o.value !== option.value;
    }));
  };

  return React.createElement("ul", {
    className: SelectListUl
  }, options.map(function (o, i) {
    var tabIndex = i + skipIndex;
    return React.createElement("li", {
      key: (o == null ? void 0 : o.key) || i
    }, React.createElement(SelectItem, {
      focused: focusIndex === tabIndex,
      tabIndex: tabIndex,
      option: o,
      onSelectionChanged: function onSelectionChanged(c) {
        return handleSelectionChanged(o, c);
      },
      checked: value.find(function (s) {
        return s.value === o.value;
      }) ? true : false,
      onClick: function onClick(e) {
        return _onClick(e, tabIndex);
      },
      itemRenderer: ItemRenderer,
      disabled: o.disabled || disabled
    }));
  }));
};
/**
 * This component represents the entire panel which gets dropped down when the
 * user selects the component.  It encapsulates the search filter, the
 * Select-all item, and the list of options.
 */


var FocusType;

(function (FocusType) {
  FocusType[FocusType["SEARCH"] = -1] = "SEARCH";
  FocusType[FocusType["NONE"] = 1] = "NONE";
})(FocusType || (FocusType = {}));

var SelectSearchContainer = /*#__PURE__*/css({
  width: "100%",
  position: "relative",
  borderBottom: "1px solid var(--rmsc-border)",
  input: {
    height: "var(--rmsc-h)",
    padding: "0 var(--rmsc-p)",
    width: "100%",
    outline: 0,
    border: 0
  }
});
var SearchClearButton = /*#__PURE__*/css({
  cursor: "pointer",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  background: "none",
  border: 0,
  padding: "0 calc(var(--rmsc-p)/2)",
  "[hidden]": {
    display: "none"
  }
});
var NoOptions = /*#__PURE__*/css({
  padding: "var(--rmsc-p)",
  textAlign: "center",
  color: "var(--rmsc-gray)"
});

var SelectPanel = function SelectPanel() {
  var _useMultiSelect2 = useMultiSelect(),
      t = _useMultiSelect2.t,
      onChange = _useMultiSelect2.onChange,
      options = _useMultiSelect2.options,
      value = _useMultiSelect2.value,
      customFilterOptions = _useMultiSelect2.filterOptions,
      selectAllLabel = _useMultiSelect2.selectAllLabel,
      ItemRenderer = _useMultiSelect2.ItemRenderer,
      disabled = _useMultiSelect2.disabled,
      disableSearch = _useMultiSelect2.disableSearch,
      focusSearchOnOpen = _useMultiSelect2.focusSearchOnOpen,
      hasSelectAll = _useMultiSelect2.hasSelectAll,
      ClearIcon = _useMultiSelect2.ClearIcon,
      debounceDuration = _useMultiSelect2.debounceDuration;

  var searchInputRef = useRef();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchText = _useState2[0],
      setSearchText = _useState2[1];

  var _useState3 = useState(options),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredOptions = _useState4[0],
      setFilteredOptions = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      searchTextForFilter = _useState6[0],
      setSearchTextForFilter = _useState6[1];

  var _useState7 = useState(focusSearchOnOpen && !disableSearch ? FocusType.SEARCH : FocusType.NONE),
      _useState8 = _slicedToArray(_useState7, 2),
      focusIndex = _useState8[0],
      setFocusIndex = _useState8[1];

  var debouncedSearch = useCallback(debounce(function (query) {
    return setSearchTextForFilter(query);
  }, debounceDuration), []);
  var selectAllOption = {
    label: selectAllLabel || t("selectAll"),
    value: ""
  };

  var selectAllValues = function selectAllValues(checked) {
    var filteredValues = filteredOptions.filter(function (o) {
      return !o.disabled;
    }).map(function (o) {
      return o.value;
    });

    if (checked) {
      var selectedValues = value.map(function (o) {
        return o.value;
      });
      var finalSelectedValues = [].concat(_toConsumableArray(selectedValues), _toConsumableArray(filteredValues));
      return filteredOptions.filter(function (o) {
        return finalSelectedValues.includes(o.value);
      });
    }

    return value.filter(function (o) {
      return !filteredValues.includes(o.value);
    });
  };

  var selectAllChanged = function selectAllChanged(checked) {
    var newOptions = selectAllValues(checked);
    onChange(newOptions);
  };

  var handleSearchChange = function handleSearchChange(e) {
    debouncedSearch(e.target.value);
    setSearchText(e.target.value);
    setFocusIndex(FocusType.SEARCH);
  };

  var handleClear = function handleClear() {
    var _searchInputRef$curre;

    setSearchTextForFilter("");
    setSearchText("");
    searchInputRef == null ? void 0 : (_searchInputRef$curre = searchInputRef.current) == null ? void 0 : _searchInputRef$curre.focus();
  };

  var handleItemClicked = function handleItemClicked(index) {
    return setFocusIndex(index);
  };

  var handleKeyDown = function handleKeyDown(e) {
    switch (e.which) {
      case 38:
        // Up Arrow
        if (e.altKey) {
          return;
        }

        updateFocus(-1);
        break;

      case 40:
        // Down Arrow
        if (e.altKey) {
          return;
        }

        updateFocus(1);
        break;

      default:
        return;
    }

    e.stopPropagation();
    e.preventDefault();
  };

  var handleSearchFocus = function handleSearchFocus() {
    setFocusIndex(FocusType.SEARCH);
  };

  var getFilteredOptions = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!customFilterOptions) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return customFilterOptions(options, searchTextForFilter);

            case 3:
              _context.t0 = _context.sent;
              _context.next = 7;
              break;

            case 6:
              _context.t0 = filterOptions(options, searchTextForFilter);

            case 7:
              return _context.abrupt("return", _context.t0);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getFilteredOptions() {
      return _ref7.apply(this, arguments);
    };
  }();

  var updateFocus = function updateFocus(offset) {
    var newFocus = focusIndex + offset;
    newFocus = Math.max(1, newFocus);
    newFocus = Math.min(newFocus, options.length + 1);
    setFocusIndex(newFocus);
  };

  var _useMemo = useMemo(function () {
    var filteredOptionsList = filteredOptions.filter(function (o) {
      return !o.disabled;
    });
    return [filteredOptionsList.every(function (o) {
      return value.findIndex(function (v) {
        return v.value === o.value;
      }) !== -1;
    }), filteredOptionsList.length !== 0]; // eslint-disable-next-line
  }, [filteredOptions, value]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      isAllOptionSelected = _useMemo2[0],
      hasSelectableOptions = _useMemo2[1];

  useEffect(function () {
    getFilteredOptions().then(setFilteredOptions);
  }, [searchTextForFilter, options]);
  return React.createElement("div", {
    className: "select-panel",
    role: "listbox",
    onKeyDown: handleKeyDown
  }, !disableSearch && React.createElement("div", {
    className: SelectSearchContainer
  }, React.createElement("input", {
    autoFocus: focusSearchOnOpen,
    placeholder: t("search"),
    type: "text",
    "aria-describedby": t("search"),
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    onChange: handleSearchChange,
    onFocus: handleSearchFocus,
    value: searchText,
    ref: searchInputRef
  }), React.createElement("button", {
    type: "button",
    className: cn(SearchClearButton, "search-clear-button"),
    hidden: !searchText,
    onClick: handleClear,
    "aria-label": t("clearSearch")
  }, ClearIcon || React.createElement(Cross, null))), hasSelectAll && hasSelectableOptions && React.createElement(SelectItem, {
    focused: focusIndex === 1,
    tabIndex: 1,
    checked: isAllOptionSelected,
    option: selectAllOption,
    onSelectionChanged: selectAllChanged,
    onClick: function onClick() {
      return handleItemClicked(1);
    },
    itemRenderer: ItemRenderer,
    disabled: disabled
  }), filteredOptions.length ? React.createElement(SelectList, {
    options: filteredOptions,
    focusIndex: focusIndex,
    onClick: function onClick(_e, index) {
      return handleItemClicked(index);
    }
  }) : React.createElement("div", {
    className: cn(NoOptions, "no-options")
  }, t("noOptions")));
};

var Arrow = function Arrow(_ref8) {
  var expanded = _ref8.expanded;
  return React.createElement("svg", {
    width: "24",
    height: "24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    className: "dropdown-heading-dropdown-arrow gray"
  }, React.createElement("path", {
    d: expanded ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"
  }));
};

var DropdownHeader = function DropdownHeader() {
  var _useMultiSelect3 = useMultiSelect(),
      t = _useMultiSelect3.t,
      value = _useMultiSelect3.value,
      options = _useMultiSelect3.options,
      valueRenderer = _useMultiSelect3.valueRenderer;

  var noneSelected = value.length === 0;
  var allSelected = value.length === options.length;
  var customText = valueRenderer && valueRenderer(value, options);

  var getSelectedText = function getSelectedText() {
    return value.map(function (s) {
      return s.label;
    }).join(", ");
  };

  return noneSelected ? React.createElement("span", {
    className: "gray"
  }, customText || t("selectSomeItems")) : React.createElement("span", null, customText || (allSelected ? t("allItemsAreSelected") : getSelectedText()));
};

var Spinner = /*#__PURE__*/css({
  animation: "rotate 2s linear infinite",
  "& .path": {
    stroke: "var(--rmsc-border)",
    strokeWidth: "4px",
    strokeLinecap: "round",
    animation: "dash 1.5s ease-in-out infinite"
  },
  "@keyframes rotate": {
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  "@keyframes dash": {
    "0%": {
      strokeDasharray: "1,150",
      strokeDashoffset: 0
    },
    "50%": {
      strokeDasharray: "90,150",
      strokeDashoffset: "-35"
    },
    "100%": {
      strokeDasharray: "90,150",
      strokeDashoffset: "-124"
    }
  }
});

var Loading = function Loading(_ref9) {
  var _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 24 : _ref9$size;
  return React.createElement("span", {
    style: {
      width: size,
      marginRight: "0.2rem"
    }
  }, React.createElement("svg", {
    width: size,
    height: size,
    className: Spinner,
    viewBox: "0 0 50 50",
    style: {
      display: "inline",
      verticalAlign: "middle"
    }
  }, React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "20",
    fill: "none",
    className: "path"
  })));
};
/**
 * A generic dropdown component.  It takes the children of the component
 * and hosts it in the component.  When the component is selected, it
 * drops-down the contentComponent and applies the contentProps.
 */


var PanelContainer = /*#__PURE__*/css({
  position: "absolute",
  zIndex: 1,
  top: "100%",
  width: "100%",
  paddingTop: "8px",
  ".panel-content": {
    maxHeight: "300px",
    overflowY: "auto",
    borderRadius: "var(--rmsc-radius)",
    background: "var(--rmsc-bg)",
    boxShadow: "0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 11px rgba(0, 0, 0, 0.1)"
  }
});
var DropdownContainer = /*#__PURE__*/css({
  position: "relative",
  outline: 0,
  backgroundColor: "var(--rmsc-bg)",
  border: "1px solid var(--rmsc-border)",
  borderRadius: "var(--rmsc-radius)",
  "&:focus-within": {
    boxShadow: "var(--rmsc-main) 0 0 0 1px",
    borderColor: "var(--rmsc-main)"
  }
});
var DropdownHeading = /*#__PURE__*/css({
  position: "relative",
  padding: "0 var(--rmsc-p)",
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "var(--rmsc-h)",
  cursor: "default",
  outline: 0,
  ".dropdown-heading-value": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flex: 1
  }
});
var ClearSelectedButton = /*#__PURE__*/css({
  cursor: "pointer",
  background: "none",
  border: 0,
  padding: 0,
  display: "flex"
});

var Dropdown = function Dropdown() {
  var _useMultiSelect4 = useMultiSelect(),
      t = _useMultiSelect4.t,
      onMenuToggle = _useMultiSelect4.onMenuToggle,
      ArrowRenderer = _useMultiSelect4.ArrowRenderer,
      shouldToggleOnHover = _useMultiSelect4.shouldToggleOnHover,
      isLoading = _useMultiSelect4.isLoading,
      disabled = _useMultiSelect4.disabled,
      onChange = _useMultiSelect4.onChange,
      labelledBy = _useMultiSelect4.labelledBy,
      value = _useMultiSelect4.value,
      isOpen = _useMultiSelect4.isOpen,
      defaultIsOpen = _useMultiSelect4.defaultIsOpen,
      ClearSelectedIcon = _useMultiSelect4.ClearSelectedIcon;

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isInternalExpand = _useState10[0],
      setIsInternalExpand = _useState10[1];

  var _useState11 = useState(defaultIsOpen),
      _useState12 = _slicedToArray(_useState11, 2),
      expanded = _useState12[0],
      setExpanded = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      hasFocus = _useState14[0],
      setHasFocus = _useState14[1];

  var FinalArrow = ArrowRenderer || Arrow;
  var wrapper = useRef();
  useDidUpdateEffect(function () {
    onMenuToggle && onMenuToggle(expanded);
  }, [expanded]);
  useEffect(function () {
    if (defaultIsOpen === undefined && typeof isOpen === "boolean") {
      setIsInternalExpand(false);
      setExpanded(isOpen);
    }
  }, [isOpen]);

  var handleKeyDown = function handleKeyDown(e) {
    var _wrapper$current;

    if (isInternalExpand) {
      switch (e.which) {
        case 27: // Escape

        case 38:
          // Up Arrow
          setExpanded(false);
          wrapper == null ? void 0 : (_wrapper$current = wrapper.current) == null ? void 0 : _wrapper$current.focus();
          break;

        case 32: // Space

        case 13: // Enter Key

        case 40:
          // Down Arrow
          setExpanded(true);
          break;

        default:
          return;
      }
    }

    e.preventDefault();
  };

  var handleHover = function handleHover(iexpanded) {
    isInternalExpand && shouldToggleOnHover && setExpanded(iexpanded);
  };

  var handleFocus = function handleFocus() {
    return !hasFocus && setHasFocus(true);
  };

  var handleBlur = function handleBlur(e) {
    if (!e.currentTarget.contains(e.relatedTarget) && isInternalExpand) {
      setHasFocus(false);
      setExpanded(false);
    }
  };

  var handleMouseEnter = function handleMouseEnter() {
    return handleHover(true);
  };

  var handleMouseLeave = function handleMouseLeave() {
    return handleHover(false);
  };

  var toggleExpanded = function toggleExpanded() {
    isInternalExpand && setExpanded(isLoading || disabled ? false : !expanded);
  };

  var handleClearSelected = function handleClearSelected(e) {
    e.stopPropagation();
    onChange([]);
    isInternalExpand && setExpanded(false);
  };

  return React.createElement("div", {
    tabIndex: 0,
    className: cn(DropdownContainer, "dropdown-container"),
    "aria-labelledby": labelledBy,
    "aria-expanded": expanded,
    "aria-readonly": true,
    "aria-disabled": disabled,
    ref: wrapper,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, React.createElement("div", {
    className: cn(DropdownHeading, "dropdown-heading"),
    onClick: toggleExpanded
  }, React.createElement("div", {
    className: "dropdown-heading-value"
  }, React.createElement(DropdownHeader, null)), isLoading && React.createElement(Loading, null), value.length > 0 && React.createElement("button", {
    type: "button",
    className: cn(ClearSelectedButton, "clear-selected-button"),
    onClick: handleClearSelected,
    disabled: disabled,
    "aria-label": t("clearSelected")
  }, ClearSelectedIcon || React.createElement(Cross, null)), React.createElement(FinalArrow, {
    expanded: expanded
  })), expanded && React.createElement("div", {
    className: cn(PanelContainer, "dropdown-content")
  }, React.createElement("div", {
    className: "panel-content"
  }, React.createElement(SelectPanel, null))));
};

var MultiSelectBox = /*#__PURE__*/css({
  "--rmscMain": "#4285f4",
  "--rmscHover": "#f1f3f5",
  "--rmscSelected": "#e2e6ea",
  "--rmscBorder": "#ccc",
  "--rmscGray": "#aaa",
  "--rmscBg": "#fff",
  "--rmscP": "10px",
  "--rmscRadius": "4px",
  "--rmscH": "38px",
  "*": {
    boxSizing: "border-box",
    transition: "all 0.2s ease"
  },
  ".gray": {
    color: "var(--rmsc-gray)"
  }
});

var MultiSelect = function MultiSelect(props) {
  return React.createElement(MultiSelectProvider, {
    props: props
  }, React.createElement("div", {
    className: cn(MultiSelectBox, props.className || "multi-select")
  }, React.createElement(Dropdown, null)));
};

export default MultiSelect;
export { Dropdown, SelectItem, SelectPanel };